import { match } from 'ts-pattern';

import { Banner } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useGetDashboardQuery } from '../queries';

export function VariantBanner() {
  const { data } = useGetDashboardQuery();
  const { t } = useTranslation();

  return match(data?.variant)
    .with('LIGHT', () => (
      <Banner
        subtitle={t('dashboard.unlockAdvanced.subtitle')}
        title={t('dashboard.unlockAdvanced.title')}
        variant="warning"
      />
    ))
    .otherwise(() => false);
}
